/**
 * PM CRM file uploads — drag-and-drop + click-to-browse uploader.
 *
 * Looks for #pm-files-card with data-object-type / data-object-id attributes.
 * Uploads POST to /pm-crm/{object_type}/{object_id}/files/upload/.
 */

(function () {

    function getCsrfToken() {
        return window._cc && window._cc.getCsrfToken ? window._cc.getCsrfToken() : '';
    }

    function initPmFileUploader(card) {
        if (!card || card.hasAttribute('data-pm-file-init')) return;
        card.setAttribute('data-pm-file-init', '');

        var objectType = card.getAttribute('data-object-type');
        var objectId = card.getAttribute('data-object-id');
        var dropzone = card.querySelector('#pm-file-dropzone');
        var fileInput = card.querySelector('#pm-file-input');
        var list = card.querySelector('#pm-file-list');
        var addBtn = card.querySelector('#pm-file-add-btn');
        var uploader = card.querySelector('#pm-file-uploader');

        if (!dropzone || !fileInput || !list) return;

        // Toggle uploader visibility
        if (addBtn && uploader) {
            addBtn.addEventListener('click', function () {
                var empty = document.getElementById('pm-file-empty');
                var showing = uploader.style.display === 'none';
                if (showing) {
                    if (empty) empty.style.display = 'none';
                    uploader.style.display = '';
                } else {
                    uploader.style.display = 'none';
                    if (empty && !list.querySelector('.list-group-item')) empty.style.display = '';
                }
            });
        }

        // Click to browse
        dropzone.addEventListener('click', function (e) {
            if (!e.target.closest('.file-uploader-action')) {
                fileInput.click();
            }
        });

        fileInput.addEventListener('change', function () {
            for (var i = 0; i < fileInput.files.length; i++) {
                uploadFile(objectType, objectId, fileInput.files[i], list);
            }
            fileInput.value = '';
        });

        // Drag and drop — use a counter to handle dragleave firing on child elements
        var dragCounter = 0;
        dropzone.addEventListener('dragenter', function (e) {
            e.preventDefault();
            dragCounter++;
            dropzone.classList.add('file-uploader-dropzone-active');
        });

        dropzone.addEventListener('dragover', function (e) {
            e.preventDefault();
        });

        dropzone.addEventListener('dragleave', function () {
            dragCounter--;
            if (dragCounter === 0) dropzone.classList.remove('file-uploader-dropzone-active');
        });

        dropzone.addEventListener('drop', function (e) {
            e.preventDefault();
            dragCounter = 0;
            dropzone.classList.remove('file-uploader-dropzone-active');
            for (var i = 0; i < e.dataTransfer.files.length; i++) {
                uploadFile(objectType, objectId, e.dataTransfer.files[i], list);
            }
        });
    }

    function uploadFile(objectType, objectId, file, list) {
        var formData = new FormData();
        formData.append('file', file);

        var empty = document.getElementById('pm-file-empty');
        if (empty) empty.style.display = 'none';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/pm-crm/' + objectType + '/' + objectId + '/files/upload/');
        xhr.setRequestHeader('X-CSRFToken', getCsrfToken());
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300 && xhr.responseText.trim()) {
                list.insertAdjacentHTML('beforeend', xhr.responseText);
                if (window.htmx) htmx.process(list);

                // Success animation
                var dzIcon = document.querySelector('#pm-file-dropzone .file-uploader-icon');
                var dzText = document.querySelector('#pm-file-dropzone .file-uploader-text');
                var dzHint = document.querySelector('#pm-file-dropzone .file-uploader-hint');
                var uploader = document.getElementById('pm-file-uploader');
                if (dzIcon && dzText) {
                    var origIcon = dzIcon.innerHTML;
                    var origText = dzText.textContent;
                    var origHint = dzHint ? dzHint.style.display : '';
                    dzIcon.innerHTML = '<i class="fa-solid fa-circle-check text-success"></i>';
                    dzText.textContent = 'Uploaded!';
                    if (dzHint) dzHint.style.display = 'none';
                    setTimeout(function () {
                        dzIcon.innerHTML = origIcon;
                        dzText.textContent = origText;
                        if (dzHint) dzHint.style.display = origHint;
                        if (uploader) uploader.style.display = 'none';
                    }, 1200);
                }
            }
        };
        xhr.send(formData);
    }

    // Re-show empty state when last file is deleted via data-success-remove.
    // Uses htmx:afterRequest (not afterSwap) because hx-swap="none" skips swap events.
    // setTimeout ensures this runs after htmx-actions.js removes the element.
    document.body.addEventListener('htmx:afterRequest', function (e) {
        var el = e.detail.elt;
        if (!el.hasAttribute('data-success-remove')) return;
        setTimeout(function () {
            var list = document.getElementById('pm-file-list');
            if (!list) return;
            if (!list.querySelector('.list-group-item')) {
                var empty = document.getElementById('pm-file-empty');
                if (empty) {
                    empty.style.display = '';
                } else {
                    list.insertAdjacentHTML('beforeend',
                        '<div class="data-table__muted" id="pm-file-empty">No files.</div>');
                }
            }
        }, 0);
    });

    // Init when card appears in DOM (sheets load content dynamically)
    var observer = new MutationObserver(function () {
        var card = document.getElementById('pm-files-card');
        if (card) initPmFileUploader(card);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Investor type multi-select filter
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-apply-investor-type-filter]');
        if (!btn) return;
        var checkboxes = document.querySelectorAll('[data-investor-type-filter]:checked');
        var params = new URLSearchParams(window.location.search);
        params.delete('investor_type');
        checkboxes.forEach(function (cb) {
            params.append('investor_type', cb.value);
        });
        window.location.search = params.toString();
    });

    // Acqs property list — signal multi-select filter
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-apply-signal-filter]');
        if (!btn) return;
        var checkboxes = document.querySelectorAll('[data-signal-filter]:checked');
        var params = new URLSearchParams(window.location.search);
        params.delete('signal');
        params.delete('signal_type');  // drop legacy alias on apply
        checkboxes.forEach(function (cb) {
            params.append('signal', cb.value);
        });
        window.location.search = params.toString();
    });

})();
